// MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS:
//   ROOT: app/assets/webpack_entry/core_webpack.wjs.jsx
// MAGIC_DESPROCKET_END
/*
 * Various widgets.
 *
 * Everything in this file is deprecated; prefer Bootstrap and/or design system
 * widgets for new code.
 *
 */
_.extend($w, {
    flash: function(message, options, callback) {
        if ('undefined' === typeof options) {
            options = {};
        }
        options.message = message;
        var widget = Widgets.Notification.create(options);
        widget.flash(callback, options);
    },

    confirm: function(message, options, callback) {
        if ('undefined' === typeof options) {
            options = {};
        }
        var widget;
        options.message = message;
        options.onYes = function() {
            widget.fadeOutAndRemove('fast', callback);
        };

        widget = Widgets.YesNo.create(options);
        widget.fadeIn();

        return widget;
    },

    // Prefer Bootstrap modal unless you really need an iframe
    // (and we need a new iframe modal widget!)
    boxover: function(options) {
        var widget = Widgets.BoxOver.create(options);
        $('#overlay_background').fadeTo("fast", .6);
        widget.show();
        $('#boxover_widget').addClass(options.classes || '');

        return widget;
    },
});
